"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const convertOversToBallsTotal = (props) => {
    if (!props.ballsPerOver)
        props.ballsPerOver = 6;
    let oB = props.overs.toString();
    let val = 0;
    if (oB.search(/\./) > -1) {
        oB = oB.split('.');
        val = Number(oB[0]) * props.ballsPerOver;
        if (Number(oB[1]) > props.ballsPerOver)
            oB[1] = props.ballsPerOver.toString();
        val = val + Number(oB[1]);
    }
    else {
        val = Number(oB) * props.ballsPerOver;
    }
    return val;
};
exports.default = convertOversToBallsTotal;
//# sourceMappingURL=convertOversToBallsTotal.js.map